(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-collection-card-action"] && !Shopify.designMode) return;
  try {
    function auraCollectionUpdateCartBubble(itemCount) {
    itemCount = Number(itemCount || 0);

    document.querySelectorAll('[data-testid="cart-bubble"], [ref="cartBubbleCount"]').forEach(function (count) {
      count.textContent = itemCount;
    });

    document.querySelectorAll('.cart-bubble .visually-hidden').forEach(function (label) {
      const prefix = label.textContent.replace(/\d+\s*$/, '');
      label.textContent = prefix + itemCount;
    });

    document.querySelectorAll('cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
    });
  }

  const auraCollectionButtonTimers = new WeakMap();

  function auraCollectionShowButtonState(button, state) {
    const existingTimer = auraCollectionButtonTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    button.classList.remove('is-added', 'is-error');

    if (state === 'added') {
      button.classList.add('is-added');
      button.textContent = '✓ ' + button.dataset.labelAdded;
    } else {
      button.classList.add('is-error');
      button.textContent = button.dataset.labelError;
    }

    const timer = window.setTimeout(function () {
      button.classList.remove('is-added', 'is-error');
      button.textContent = button.dataset.labelAdd;
      auraCollectionButtonTimers.delete(button);
    }, 2400);

    auraCollectionButtonTimers.set(button, timer);
  }

  async function auraCollectionAddProduct(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    const originalLabel = button.dataset.labelAdd;
    const currentCountElement = document.querySelector('[data-testid="cart-bubble"], [ref="cartBubbleCount"]');
    const currentItemCount = Number(currentCountElement && currentCountElement.textContent.trim()) || 0;
    const existingTimer = auraCollectionButtonTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);
    button.classList.remove('is-added', 'is-error');
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.labelAdding;

    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const payload = {
        items: [
          {
            id: Number(button.dataset.variantId),
            quantity: 1
          }
        ]
      };

      const addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const added = await addResponse.json();

      if (!addResponse.ok || added.status) {
        throw new Error(added.description || added.message || button.dataset.labelError);
      }

      auraCollectionUpdateCartBubble(currentItemCount + 1);
      auraCollectionShowButtonState(button, 'added');
    } catch (error) {
      auraCollectionShowButtonState(button, 'error');
    } finally {
      button.removeAttribute('aria-busy');
      if (!button.classList.contains('is-added') && !button.classList.contains('is-error')) {
        button.textContent = originalLabel;
      }
    }
  }

  if (!window.auraCollectionCardActionsReady) {
    window.auraCollectionCardActionsReady = true;

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-aura-collection-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      auraCollectionAddProduct(button);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
